import { Plugin } from '@nuxt/types'
import { ReWriteCardService } from '@/services/ReWriteCardService'

declare module 'vue/types/vue' {
  interface Vue {
    $reWriteCard: ReWriteCardService
  }
}

declare module '@nuxt/vue-app' {
  interface NuxtAppOptions {
    $reWriteCard: ReWriteCardService
  }
}

const plugin: Plugin = (context, inject) =>
  inject('reWriteCard', new ReWriteCardService())

export default plugin
